var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-fade-transition',{attrs:{"mode":"out-in"}},[(!_vm.errorPageCode)?_c('router-view'):_c('error-page',{attrs:{"error-code":_vm.errorPageCode,"error-message":_vm.errorMessage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }